import React from 'react'
import PropTypes from 'prop-types'
import { PrismicRichText } from '@prismicio/react'
import Indicator from './svg/indicator'

const Accordion = ({ slice }) => {
  return (
    <section className='component-accordion mx-auto w-full max-w-screen-lg px-6 pt-8 pb-10 md:py-10'>
      <div className='prose max-w-none md:mb-8'>
        <PrismicRichText field={slice.primary.title.richText} />
        <PrismicRichText field={slice.primary.text.richText} />
      </div>
      <div className='mx-auto mt-3 divide-y divide-stone-200'>
        {slice.items.map((accordion, index) => {
          return (
            <details className='transform overflow-hidden transition-all' key={`accordion-${index}`}>
              <summary className='flex w-full cursor-pointer py-4 md:px-4 justify-between text-lg font-bold text-brand-blue hover:text-brand-orange'>
                <PrismicRichText field={accordion.question.richText} />
                <div className='indicator flex items-center'>
                  <Indicator className='w-8' />
                </div>
              </summary>
              <div className='prose max-w-none pr-12 transition-all pb-6 pl-2 md:pl-4'>
                <PrismicRichText field={accordion.answer.richText} />
              </div>
            </details>
          )
        })}
      </div>
    </section>
  )
}

Accordion.propTypes = {
  slice: PropTypes.object.isRequired
}

export default Accordion
